import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { Tenant, TenantPatch } from '../models';

export const TenantsActions = createActionGroup({
  source: 'Tenants',
  events: {
    Load: emptyProps(),
    'Load Success': props<{ tenants: Tenant[]; env: string }>(),
    'Load Failure': props<{ error: string }>(),

    'Save Tenant': props<{ tenantId: string; patch: TenantPatch }>(),
    'Save Tenant Success': props<{ tenant: Tenant }>(),
    'Save Tenant Failure': props<{ error: string }>(),

    /**
     * Upsert from the registration wizard, which calls the API directly (the
     * one-time client secret and step mechanics stay component-local) and
     * reports each server-confirmed tenant back to the list here.
     */
    'Tenant Changed': props<{ tenant: Tenant }>(),
  },
});
